import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { BreadCrumb } from "../../../Layout/Common/breadCrumb";
import React, { useEffect, useRef, useState } from "react";
import { useNoteAlert } from "../../../Context/pleaseNote";
import { useAuth } from "../../../Context/AuthContext";
import { axiosInstance } from "../../../axios/axiosInstance";
import { PAGES } from "../../../routeConfig";
import { Formik, Form, Field, ErrorMessage, useFormikContext } from "formik";
import { isAlphaNumericAndSpace_, isNumberOnly } from "../../../Layout/Common/common";
import * as Yup from "yup";
import { FormikErrorMessage } from "../../../Layout/Common/fromikErrorMessage";
import { CancelButton } from "../../../Layout/Common/cancelButton";
export const CompanyUsersEditusers = () => {
  const { userid } = useParams();
  const navigate = useNavigate();
  const [hasFocusedError, setHasFocusedError] = React.useState(false);
  const { showNoteAlert, showRestrictionAlert } = useNoteAlert();
  const [showerrorBorder, setshowerrorBorder] = React.useState(false);
  const [isProcessing, setIsProcessing] = React.useState(false);
  const [showUpdate, setshowUpdate] = React.useState(false);
  const [DropShipmentDisable, setDropShipmentDisable] = React.useState(false);
  const [DataDetails, setDataDetails] = React.useState(null);
  const histroy = useNavigate();
  const [UserDel, setUserDel] = useState(null);
  const [loginidDisable, setloginidDisable] = React.useState(false);
  const [loginname, setloginname] = React.useState("");
  const [submitCount, setSubmitCount] = React.useState("");
  const [errorSubmit, setErrorSubmit] = React.useState("");
  const inputsRef = useRef([]);
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s])[^\s]{8,12}$/;

  const { userId, companyId, setUser, setAthuLoading, emailAddress, role } = useAuth();
  const handleNavigation = () => {
    histroy("/myaccount");
  };
  useEffect(() => {
    if (showUpdate) {
      window.scrollTo(0, 0);
      //  window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [showUpdate]);
  useEffect(() => {
    if (userid != null) handleSearchClick();
    else {
      handleAddClick();
    }
  }, []);
  useEffect(() => {
    if (userid != null) {
      if (DataDetails != null) {
        let UserLiseDel = DataDetails ?? {};
        setUserDel({
          form_fullName: UserLiseDel.fullName,
          form_mobNumber: UserLiseDel.mobNumber,
          form_phNumber: UserLiseDel.phNumber,
          form_email: UserLiseDel.email,
          signatureReq: UserLiseDel.userRole,
          loginid: UserLiseDel.loginid,
          changePwd: UserLiseDel.newPws,
          confirmPwd: UserLiseDel.confornPws,
          DropShipment: UserLiseDel.dropShipment,
          userId: parseInt(userid, 10),
        });
      }
    }
  }, [DataDetails]);
  const handleSearchClick = async () => {
    var data = {
      UserID: parseInt(userid, 10),
      CompanyID: companyId,
    };
    axiosInstance
      .post("CompanyUsers/EditUserDetails", data)
      .then((response) => {
        if (response.data != "") {
          let res = response.data;

          setDropShipmentDisable(res.dropShipmentDisable);

          setloginname(res.loginid);
          setDataDetails(res);
        } else {
          showRestrictionAlert({
            content: `<p class="text-center col-fs-14 fs-15 fw-normal">Invalid Company user.</p>`,
            title: "Restricted Area",
            showCloseBtn: true,
            icon: "wes-address-home",
            crossButton: false,
            closeBtnFunction: () => {
              histroy("/myaccount");
            },
          });
        }
      })
      .catch((error) => console.log(error.message));
  };
  const handleAddClick = async () => {
    var data = {
      UserId: parseInt(userId, 10),
      CompanyID: companyId,
    };
    axiosInstance
      .post("CompanyUsers/GetUserLoginID", data)
      .then((response) => {
        if (response.data != null) {
          let res = response.data;
          setDropShipmentDisable(res.dropShipmentDisable);
          setUserDel({
            form_fullName: "",
            form_mobNumber: "",
            form_phNumber: "",
            form_email: "",
            signatureReq: "",
            loginid: res.userId,
            changePwd: "",
            confirmPwd: "",
            DropShipment: false,
            userId: parseInt(userId, 10),
          });

          setloginidDisable(true);
        }
      })
      .catch((error) => console.log(error.message));
  };
  const validationSchema = (userid) =>
    Yup.object({
      form_fullName: Yup.string()
        .required("Full Name is required")
        .matches(/^[a-zA-Z\s]+$/, "Only letters and spaces are allowed"),

      form_mobNumber: Yup.string()
        .nullable()
        .trim()
        .test("mobile-format", "Mobile No must start with 04 and be exactly 10 digits", (value) => {
          // Allow empty/null
          if (!value || value.trim() === "") return true;
          // Validate pattern
          return /^04\d{8}$/.test(value);
        }),

      form_phNumber: Yup.string(),

      form_email: Yup.string()
        .transform((value) => (typeof value === "string" ? value.trim() : value))
        .required("Email is required")
        .matches(/^[A-Za-z0-9+_.%-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/, "Invalid email address"),
      signatureReq: Yup.string().required("Please select a user permission"),
      ...(userid != null
        ? {
            loginid: Yup.string().required("User Login ID is required"),
          }
        : {}),

      changePwd: Yup.string()
        .required("New Password is required")
        .matches(
          passwordRegex,
          "Password must be 8–12 characters, include uppercase, lowercase, number, special character, and no spaces",
        ),
      confirmPwd: Yup.string()
        .required("Confirm Password is required")
        .oneOf([Yup.ref("changePwd"), null], "Passwords must match"),
      DropShipment: Yup.boolean(),
    });

  const ScrollToError = () => {
    // const { errors, submitCount } = useFormikContext();
    React.useEffect(() => {
      if (submitCount > 0 && Object.keys(errorSubmit).length > 0) {
        const firstError = Object.keys(errorSubmit)[0];
        const element = document.querySelector(`[name="${firstError}"]`);

        if (element) {
          element.focus();

          if (firstError === "signatureReq") {
            window.scrollTo({ top: 400, behavior: "smooth" });
          }
        }
      }
    }, [errorSubmit, submitCount]);
    return null;
  };
  const onResetPasswordClick = (values) => {
    var data = {
      UserId: parseInt(userid, 10),
      loginname: loginname,
    };

    axiosInstance
      .post("CompanyUsers/ResetPassword", data)
      .then((response) => {
        if (response.data != "") {
          if (response.data == "Success") {
            showNoteAlert("Email Send Succesfully!");
          } else {
            showNoteAlert(response.data);
          }
        }
      })
      .catch((error) => {
        setIsProcessing(false);
        setshowUpdate(!showUpdate);
      });
  };
  const handleSubmit = (values) => {
    setIsProcessing(true);
    var data = {
      rdata: values,
    };

    let urlConrtol = userid ? "CompanyUsers/SubmitClick" : "CompanyUsers/AddClick";

    axiosInstance
      .post(urlConrtol, values)
      .then((response) => {
        if (response.data != "") {
          if (response.data == "Success") {
            document.getElementById("divShowDetails").style.display = "none";
            document.getElementById("divUpdateSuccess").style.display = "block";

            setIsProcessing(false);
            setshowUpdate(!showUpdate);
          } else if (response.data == "Login Name Already Exists") {
            setshowerrorBorder(true);
          } else {
            showNoteAlert(response.data);
            setIsProcessing(false);
            setshowUpdate(!showUpdate);
          }
        }
      })
      .catch((error) => {
        setIsProcessing(false);
        setshowUpdate(!showUpdate);
      });
  };
  const onSubmitClick = (Validatevalues, errorsList, values) => {

    if (Validatevalues === true) {
    } else {
      setHasFocusedError(false);
    }
  };
  const setInuputRefs = (el) => {
    if (el && !inputsRef.current.includes(el)) {
      inputsRef.current.push(el);
    }
  };
  const handleKeyDown = (e, formik) => {
    if (e.key === "Enter" || e.key === "Tab") {
      e.preventDefault();

      const currentIndex = inputsRef.current.indexOf(e.target);
      const fieldName = e.target.name;
      const value = e.target.value;
      const isRequired = e.target.required;

      if (isRequired && !value) {
        formik.setFieldTouched(fieldName, true, true);
        formik.validateField(fieldName);
        return;
      }

      const nextInput = inputsRef.current[currentIndex + 1];
      if (nextInput) {
        setTimeout(() => {
          nextInput.focus();
        }, 0);
      }
    }
  };
  return (
    <>
      <BreadCrumb
        data={[
          { name: "My Account", url: PAGES.MYACCOUNT },
          { name: "My Company Users", url: PAGES.COMPANYUSERS },
          userid == null
            ? { name: "Add User", url: PAGES.COMPANYUSERADD }
            : { name: "Edit User", url: PAGES.COMPANYUSEREDIT },
        ]}
      />
      <section className="myAccount-section">
        <div className="container-fluid container-lg" id="divShowDetails">
          <div className="row">
            <div className="col-lg-12">
              <div className="acc-header py-3">
                <div className="myaccount-address myAccount-header">
                  <h1 className="myaccount-title">{userid == null ? <>Add User</> : <> Edit User</>}</h1>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-8">
              {/* {UserDel != null && UserDel!="" ? (*/}
              <Formik
                initialValues={UserDel}
                validationSchema={validationSchema(userid)}
                onSubmit={handleSubmit}
                enableReinitialize={true}
              >
                {({
                  setFieldValue,
                  isValid,
                  errors,
                  touched,
                  submitCount,
                  resetForm,
                  validateForm,
                  values,
                  ...formik
                }) => (
                  <Form noValidate>
                    <ScrollToError />
                    <div className="shippChange-address">
                      <h3 className="fs-6 fw-semibold mb-3">User Details</h3>
                      <div className="row">
                        <div className="col-md-6 col-lg-6">
                          <div className="floating-input mb-3">
                            <Field
                              id="form_fullName"
                              name="form_fullName"
                              className={`form-control form-input ${
                                touched.form_fullName && errors.form_fullName ? "error-message" : ""
                              }`}
                              type="text"
                              onChange={(e) => {
                                setFieldValue("form_fullName", isAlphaNumericAndSpace_(e.target.value));
                              }}
                              innerRef={setInuputRefs}
                              onKeyDown={(e) => handleKeyDown(e, formik)}
                              required
                            />
                            <label htmlFor="form_fullName">
                              Full Name
                              <span className="gl-form-asterisk">*</span>
                            </label>

                            <ErrorMessage name="form_fullName">
                              {(msg) => <FormikErrorMessage message={msg} />}
                            </ErrorMessage>
                          </div>
                        </div>

                        <div className="col-md-6 col-lg-6">
                          <div className="floating-input mb-3">
                            <Field
                              id="form_mobNumber"
                              name="form_mobNumber"
                              className={`form-control form-input ${
                                touched.form_mobNumber && errors.form_mobNumber ? "error-message" : ""
                              }`}
                              type="text"
                              onChange={(e) => {
                                setFieldValue("form_mobNumber", isNumberOnly(e.target.value));
                              }}
                              onKeyDown={(e) => handleKeyDown(e, formik)}
                              maxLength="10"
                              innerRef={setInuputRefs}
                            />
                            <label htmlFor="form_mobNumber" className={`${values?.form_mobNumber ? "" : "empty"}`}>
                              Mobile Number
                            </label>
                            <ErrorMessage name="form_mobNumber">
                              {(msg) => <FormikErrorMessage message={msg} />}
                            </ErrorMessage>
                          </div>
                        </div>

                        <div className="col-md-6 col-lg-6">
                          <div className="floating-input mb-3">
                            <Field
                              id="form_phNumber"
                              name="form_phNumber"
                              className={`form-control form-input ${
                                touched.form_phNumber && errors.form_phNumber ? "error-message" : ""
                              }`}
                              type="text"
                              onChange={(e) => {
                                setFieldValue("form_phNumber", isNumberOnly(e.target.value));
                              }}
                              onKeyDown={(e) => handleKeyDown(e, formik)}
                              innerRef={setInuputRefs}
                            />
                            <label htmlFor="form_phNumber" className={`${values?.form_phNumber ? "" : "empty"}`}>
                              Phone Number
                            </label>

                            <ErrorMessage name="form_phNumber">
                              {(msg) => <FormikErrorMessage message={msg} />}
                            </ErrorMessage>
                          </div>
                        </div>

                        <div className="col-md-6 col-lg-6">
                          <div className="floating-input mb-3">
                            <Field
                              id="form_email"
                              name="form_email"
                              className={`form-control form-input ${
                                touched.form_email && errors.form_email ? "error-message" : ""
                              }`}
                              type="text"
                              onChange={(e) => {
                                setFieldValue("form_email", e.target.value);
                              }}
                              onKeyDown={(e) => handleKeyDown(e, formik)}
                              innerRef={setInuputRefs}
                              required
                            />
                            <label htmlFor="form_email">
                              Email <span className="gl-form-asterisk">*</span>
                            </label>

                            <ErrorMessage name="form_email">
                              {(msg) => <FormikErrorMessage message={msg} />}
                            </ErrorMessage>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="receiver-details company-addusers">
                      <h3 className="fs-6 fw-semibold mb-3 d-flex align-items-center column-gap-2">
                        User Permission Level{" "}
                        <span
                          className="wes-info-cc bg-darkGrey"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-title="Based on the level of the user, you can give"
                        ></span>
                      </h3>

                      <div className="row">
                        <div className="col-6 col-lg-3">
                          <div className="userPermission mb-3 mb-lg-0">
                            <Field
                              type="radio"
                              name="signatureReq"
                              id="signatureReq1"
                              value="4"
                              className="form-check-input"
                              onChange={(e) => {
                                setFieldValue("signatureReq", e.target.value);
                              }}
                              innerRef={setInuputRefs}
                              onKeyDown={(e) => handleKeyDown(e, formik)}
                            />
                            <label className="userPermission-info p-2 p-xl-3 w-100" htmlFor="signatureReq1">
                              <span className="wes-global mb-2"></span>
                              Browse Only
                            </label>
                          </div>
                        </div>

                        <div className="col-6 col-lg-3">
                          <div className="userPermission mb-3 mb-lg-0">
                            <Field
                              type="radio"
                              name="signatureReq"
                              id="signatureReq2"
                              value="3"
                              className="form-check-input"
                              onChange={(e) => {
                                setFieldValue("signatureReq", e.target.value);
                              }}
                              innerRef={setInuputRefs}
                              onKeyDown={(e) => handleKeyDown(e, formik)}
                            />
                            <label className="userPermission-info p-2 p-xl-3 w-100" htmlFor="signatureReq2">
                              <span className="wes-box mb-2"></span>
                              Create Order Only
                            </label>
                          </div>
                        </div>

                        <div className="col-6 col-lg-3">
                          <div className="userPermission mb-3 mb-lg-0">
                            <Field
                              type="radio"
                              name="signatureReq"
                              id="signatureReq3"
                              value="2"
                              className="form-check-input"
                              onChange={(e) => {
                                setFieldValue("signatureReq", e.target.value);
                              }}
                              innerRef={setInuputRefs}
                              onKeyDown={(e) => handleKeyDown(e, formik)}
                            />
                            <label className="userPermission-info p-2 p-xl-3 w-100" htmlFor="signatureReq3">
                              <span className="wes-box-tick mb-2"></span>
                              Submit / Approve
                            </label>
                          </div>
                        </div>

                        <div className="col-6 col-lg-3">
                          <div className="userPermission mb-3 mb-lg-0">
                            <Field
                              type="radio"
                              name="signatureReq"
                              id="signatureReq4"
                              value="1"
                              className="form-check-input"
                              disabled={true}
                              onChange={(e) => {
                                setFieldValue("signatureReq", e.target.value);
                              }}
                              innerRef={setInuputRefs}
                              onKeyDown={(e) => handleKeyDown(e, formik)}
                            />
                            <label className="userPermission-info p-2 p-xl-3 w-100" htmlFor="signatureReq4">
                              <span className="wes-user-octagon mb-2"></span>
                              Admin Users
                            </label>
                          </div>
                        </div>
                      </div>

                      <ErrorMessage name="signatureReq">{(msg) => <FormikErrorMessage message={msg} />}</ErrorMessage>
                    </div>
                    <div className="dropShipment-password mt-5 company-userPwd">
                      <h3 className="fs-6 fw-semibold mb-3">User Login ID </h3>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="floating-input changedPwd mb-3">
                            <Field
                              id="loginid"
                              name="loginid"
                              type="text"
                              className={`form-control form-input ${
                                (touched.loginid && errors.loginid) || showerrorBorder ? "error-message" : ""
                              }`}
                              onChange={(e) => {
                                if (loginidDisable === false) setFieldValue("loginid", e.target.value);
                              }}
                              disabled={loginidDisable}
                              innerRef={setInuputRefs}
                              onKeyDown={(e) => handleKeyDown(e, formik)}
                              required
                            />
                            <label htmlFor="loginid">
                              User Login ID
                              <span className="gl-form-asterisk">*</span>
                            </label>

                            <ErrorMessage name="loginid">{(msg) => <FormikErrorMessage message={msg} />}</ErrorMessage>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="dropShipment-password mt-5 company-userPwd">
                      <h3 className="fs-6 fw-semibold mb-3">
                        User Password{" "}
                        {userid == null ? (
                          <></>
                        ) : (
                          <a
                            role="button"
                            tabIndex={0}
                            onClick={() => onResetPasswordClick()}
                            onKeyDown={(e) => {
                              if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                onResetPasswordClick();
                              }
                            }}
                            className="text-decoration-underline"
                          >
                            Send Password Reset Email
                          </a>
                        )}
                      </h3>

                      <div className="row">
                        <div className="col-lg-6">
                          <div className="floating-input changedPwd mb-3">
                            <Field
                              id="changePwd"
                              name="changePwd"
                              type="password"
                              className={`form-control form-input ${
                                touched.changePwd && errors.changePwd ? "error-message" : ""
                              }`}
                              onChange={(e) => {
                                setFieldValue("changePwd", e.target.value);
                              }}
                              innerRef={setInuputRefs}
                              onKeyDown={(e) => handleKeyDown(e, formik)}
                              required
                            />
                            <label htmlFor="changePwd">
                              New Password
                              <span className="gl-form-asterisk">*</span>
                            </label>

                            <ErrorMessage name="changePwd">
                              {(msg) => <FormikErrorMessage message={msg} />}
                            </ErrorMessage>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-input changedPwd mb-3">
                            <Field
                              id="confirmPwd"
                              name="confirmPwd"
                              type="password"
                              className={`form-control form-input ${
                                touched.confirmPwd && errors.confirmPwd ? "error-message" : ""
                              }`}
                              onChange={(e) => {
                                setFieldValue("confirmPwd", e.target.value);
                              }}
                              innerRef={setInuputRefs}
                              onKeyDown={(e) => handleKeyDown(e, formik)}
                              required
                            />
                            <label htmlFor="confirmPwd">
                              Confirm Password <span className="gl-form-asterisk">*</span>
                            </label>

                            <ErrorMessage name="confirmPwd">
                              {(msg) => <FormikErrorMessage message={msg} />}
                            </ErrorMessage>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="dropShipment-orders mt-4">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-check custom-check">
                            <div className="signature-req-input">
                              <Field
                                type="checkbox"
                                name="DropShipment"
                                id="DropShipmentOrders"
                                className="form-check-input"
                                disabled={DropShipmentDisable}
                                innerRef={setInuputRefs}
                                onKeyDown={(e) => handleKeyDown(e, formik)}
                              />
                            </div>
                            <label className="form-check-label col-fs-13 fs-14 fw-normal" htmlFor="DropShipmentOrders">
                              Allow User to Create Dropshipment Orders
                            </label>
                          </div>

                          <ErrorMessage name="DropShipment">
                            {(msg) => <FormikErrorMessage message={msg} />}
                          </ErrorMessage>
                        </div>
                      </div>
                    </div>
                    <div
                      className="toast show fav-error-toast w-100 mt-3"
                      role="alert"
                      aria-live="assertive"
                      aria-atomic="true"
                      style={{ display: showerrorBorder ? "block" : "none" }}
                    >
                      <div className="toast-body fav-orderno-not d-flex align-content-center justify-content-between">
                        <div className="fav-ordernoNot-lft d-flex align-items-start justify-content-between">
                          <div>
                            <svg
                              width="47"
                              height="47"
                              viewBox="0 0 47 47"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect width="47" height="47" rx="23.5" fill="#F8A026" fillOpacity="0.2"></rect>
                              <rect x="3" y="3" width="41" height="41" rx="20.5" fill="#F8A026"></rect>
                              <path
                                d="M23.5 20.875V25.25"
                                stroke="white"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                              <path
                                d="M23.5 31.7339H18.1975C15.1613 31.7339 13.8925 29.5639 15.3625 26.9126L18.0925 21.9951L20.665 17.3751C22.2225 14.5664 24.7775 14.5664 26.335 17.3751L28.9075 22.0039L31.6375 26.9214C33.1075 29.5726 31.83 31.7426 28.8025 31.7426H23.5V31.7339Z"
                                stroke="white"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                              <path
                                d="M23.4951 27.875H23.503"
                                stroke="white"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                            </svg>
                          </div>
                          <div className="fav-ordernoNot-info">
                            <h5 className="fw-semibold">User Name Not Available</h5>
                            <p className="fw-medium fs-14 m-0">
                              The username you entered is not available. Please try another one
                            </p>
                          </div>
                        </div>
                        <div className="ct-close">
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="toast"
                            aria-label="Close"
                          ></button>
                        </div>
                      </div>
                    </div>

                    <div className="saveAddress-btn">
                      <div className="button-effect">
                        <button
                          type="submit"
                          className="btn btn-products btn-addcart"
                          disabled={isProcessing}
                          onClick={() => onSubmitClick(isValid, errors, setFieldValue)}
                        >
                          {isProcessing ? "Processing..." : userid == null ? "Create Account" : "Update"}
                        </button>
                      </div>

                      <CancelButton
                        onClick={() => {
                          navigate(-1);
                        }}
                      />
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
        <div className="container-fluid container-lg" id="divUpdateSuccess" style={{ display: "none" }}>
          <div className="row">
            <div className="col-lg-12">
              <div className="pwd-success-section">
                <div className="row">
                  <div className="col-md-12 col-lg-6 offset-lg-3">
                    <div className="loginVerification-wrapper text-center">
                      <div className="loginVerification-wrapperTitle">
                        <svg
                          className="loginVerification-check"
                          width="60"
                          height="61"
                          viewBox="0 0 60 61"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M30 55.5C43.75 55.5 55 44.25 55 30.5C55 16.75 43.75 5.5 30 5.5C16.25 5.5 5 16.75 5 30.5C5 44.25 16.25 55.5 30 55.5Z"
                            stroke="#3BA429"
                            strokeWidth="3.375"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                          <path
                            d="M19.375 30.4998L26.45 37.5748L40.625 23.4248"
                            stroke="#3BA429"
                            strokeWidth="3.375"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          ></path>
                        </svg>
                        {userid == null ? (
                          <>
                            <h1 className="fw-semibold mt-4">Comapny User Added Successfully!</h1>
                            <p className="fs-14 fw-normal">Your Comapny User Added successfully.</p>
                          </>
                        ) : (
                          <>
                            <h1 className="fw-semibold mt-4">Comapny User Updated Successfully!</h1>
                            <p className="fs-14 fw-normal">Your Comapny User Updated successfully.</p>
                          </>
                        )}
                        <div className="button-effect loginPwd-updateBtn">
                          <Link to="/myaccount/company-users" className="btn btn-products btn-addcart">
                            Back to My Company Users
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
